export enum DocumentStatus {
	PROCESSING_FILE = 'PROCESSING_FILE',
	WAITING_SIGNATORIES = 'WAITING_SIGNATORIES',
	WAITING_SIGNATURES = 'WAITING_SIGNATURES',
	PROCESSING_SIGNATURES = 'PROCESSING_SIGNATURES',
	SIGNED = 'SIGNED',
	CANCELED = 'CANCELED',
	ERROR = 'ERROR'
}